import React from "react";
import { useParams } from "react-router-dom";
import { Badge, Box, Flex, Spinner } from "@chakra-ui/react";
import { Text } from "@chakra-ui/react";

import {
  AcatsDtccTransferStatusDescriptions,
  AcatsDtccTransferTypeDescriptions,
} from "../../../api/acats/acats";
import { useAcatsTransfer } from "../../../api/acats/getAcatsTransfer";
import Header from "../../../components/layout/Header";
import { fmtCellValue, toStartCase } from "../../../globals/utils";

import AcatsAssetsTable from "./AcatsAssets";
import AcatsTransferDetails from "./AcatsTransferDetails";

const AcatsTransferPage = (): JSX.Element => {
  const { accountID, acatsID } = useParams();
  const { data, isLoading } = useAcatsTransfer(accountID, acatsID);

  if (!data || isLoading) {
    return (
      <Box>
        <Header title={`Transactions > ACATS > Details`} />
        <Flex alignItems="center" justifyContent="center" height="200px">
          <Spinner size="xl" />
        </Flex>
      </Box>
    );
  }

  const transferDirection = toStartCase(data.direction);
  const transferType =
    AcatsDtccTransferTypeDescriptions[data.transfer_type] ?? data.transfer_type;

  const controlNumber = data.transfer_identifier
    ? `- ${data.transfer_identifier}`
    : "";
  const title = `${transferDirection} ${transferType} ${controlNumber}`;

  return (
    <>
      <Header title={`ACATS > Transfers > Details`} />
      <Box>
        <Flex alignItems="center" gap="0.75rem" mb="1rem">
          <Text
            fontSize="2xl"
            fontWeight="semibold"
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
          >
            {title}
          </Text>
          <Badge>
            {fmtCellValue(
              data.status.dtcc_status
                ? AcatsDtccTransferStatusDescriptions[data.status.dtcc_status]
                : ""
            )}
          </Badge>
          <Badge>
            {fmtCellValue(toStartCase(data?.status.transfer_status ?? ""))}
          </Badge>
        </Flex>
        <AcatsTransferDetails data={data} />
        <AcatsAssetsTable accountID={data.account_id} acatsID={acatsID} />
      </Box>
    </>
  );
};

export default AcatsTransferPage;
